// Константы для компонента AllUsers
export const ROWS_PER_PAGE = 30;

export const API_ENDPOINTS = {
  USERS: 'https://tbl.zerdegroup.kz/api/users',
  CHANGE_REGION: 'https://tbl.zerdegroup.kz/api/change-region',
  CHANGE_PASSWORD: 'https://tbl.zerdegroup.kz/api/change-password',
  CHANGE_ROLE: 'https://tbl.zerdegroup.kz/api/change-role',
  CHANGE_PHARMACY: 'https://tbl.zerdegroup.kz/api/change-pharmacy',
  DELETE_USER: 'https://tbl.zerdegroup.kz/api/user',
  TOGGLE_ACTIVATION: 'https://tbl.zerdegroup.kz/api/toggle-activation',
  TOGGLE_POS: 'https://tbl.zerdegroup.kz/api/toggle-pos',
  TOGGLE_REPORTS: 'https://tbl.zerdegroup.kz/api/toggle-reports',
  MASS_REPORTS_LOCK: 'https://tbl.zerdegroup.kz/api/mass-reports-lock',
  MASS_POS_LOCK: 'https://tbl.zerdegroup.kz/api/mass-pos-lock',
  CHANGE_USER_ID: 'https://tbl.zerdegroup.kz/api/change-user-id',
  CHANGE_PHARMACY_NUM: 'https://tbl.zerdegroup.kz/api/change-pharmacy-num',
  LOG: 'https://tbl.zerdegroup.kz/api/log',
  REGIONS: 'https://tbl.zerdegroup.kz/api/regions',
  USER_DATA_UPDATE: 'https://tbl.zerdegroup.kz/api/user-data-update'
} as const;

export const ROLE_MAP = {
  'admin': 'Админ',
  'moder': 'Модератор',
  'view': 'Просмотр',
  'guide': 'Справочная',
  'user': 'Аптека',
  'storage': 'Склад',
  'km': 'Отдел КМ',
  'to': 'Торг. отдел',
  'full-report': 'Доступ к отчетам'
} as const;

export const ROLE_PRIORITIES = {
  'admin': 1,
  'moder': 2,
  'view': 3,
  'guide': 4,
  'user': 5,
  'storage': 6,
  'km': 7,
  'to': 8,
  'full-report': 9
} as const;

export const SEARCH_COLUMNS = [
  { value: 'username', label: 'Логин' },
  { value: 'pharmacyNum', label: '№ аптеки' },
  { value: 'cityId', label: 'Регион' },
  { value: 'role', label: 'Роль' },
  { value: 'id', label: 'ID' },
  { value: 'userphone', label: 'Телефон' },
  { value: 'fullName', label: 'ФИО' },
  { value: 'iin', label: 'ИИН' }
] as const;

export const ROLE_OPTIONS = [
  { value: 'user', label: 'Аптека' },
  { value: 'storage', label: 'Склад' },
  { value: 'guide', label: 'Справочная' },
  { value: 'view', label: 'Просмотр' },
  { value: 'km', label: 'Отдел КМ' },
  { value: 'to', label: 'Торг. отдел' },
  { value: 'moder', label: 'Модератор' },
  { value: 'full-report', label: 'Доступ к отчетам' }
] as const;

